import React from 'react'

function DashboardEvents() {
  return <>
    <div>Bu sayfa PRivate Event Sayfasıdır</div>
  </>
}

export default DashboardEvents